import React from 'react';

/**
 * Label + control + hint/error wrapper using the design-system .field classes.
 * The child control must carry `id` so the label's htmlFor resolves.
 *   <Field id="page-slug" label="Slug" required error={errors.slug} hint="...">
 *     <input id="page-slug" className="input" ... />
 *   </Field>
 */
export default function Field({ id, label, required, hint, error, labelExtra, children, style }) {
  return (
    <div className="field" style={style}>
      <label
        htmlFor={id}
        style={labelExtra ? { display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 8 } : undefined}
      >
        <span>
          {label}
          {required && <span aria-hidden="true" style={{ color: 'var(--color-danger)' }}> *</span>}
        </span>
        {labelExtra}
      </label>
      {children}
      {error ? (
        <span className="error" id={`${id}-error`} role="alert">{error}</span>
      ) : hint ? (
        <span className="hint" id={`${id}-hint`}>{hint}</span>
      ) : null}
    </div>
  );
}

/* Checkbox with its own label; ids are required for a11y. */
export function CheckField({ id, label, checked, onChange, hint }) {
  return (
    <div className="field">
      <label className="field-inline" htmlFor={id}>
        <input id={id} type="checkbox" checked={!!checked} onChange={(e) => onChange(e.target.checked)} />
        <span>{label}</span>
      </label>
      {hint && <span className="hint" style={{ marginLeft: 24 }}>{hint}</span>}
    </div>
  );
}
